const React = require('react');
const IconButton = require('@material-ui/core/IconButton').default;
const Visibility = require('@material-ui/icons/Visibility').default;
const VisibilityOff = require('@material-ui/icons/VisibilityOff').default;
const TextField = require('../A');


module.exports = ({
  onClickVisible,
  visible,
  ...props
}) => {
  const VisibilityIcon = visible ? VisibilityOff : Visibility;

  return (
    <TextField
      {...props}
      className={`(pr45|(f18|ff_Verdana,sans-serif|o100|c0):i!)>input
        o0>input:f:i
        o0.error>input:i `
        + (props.value ? 'filled ' : '')
        + (props.className || '')}
      type={visible ? 'text' : 'password'}
      placeholder="●●●●●●●●●●●●"
      autoComplete="new-password"
      endAdornment={(
        <div className="abs svr z1 layoutRow fhaC fvaC olN-i>1">
          <IconButton onClick={onClickVisible || null}>
            <VisibilityIcon
              className="c0C"
            />
          </IconButton>
        </div>
      )}
    />
  );
};
